import { useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { useTheme } from './ThemeContext';
import { FaBell, FaLock, FaPalette, FaLanguage, FaDatabase, FaShieldAlt, FaSave, FaTimes, FaCog } from 'react-icons/fa';
import './Settings.css';

function Settings({ onClose }) {
  const { user, token } = useAuth();
  const { isDarkMode, toggleDarkMode } = useTheme();
  const [settings, setSettings] = useState({
    notifications: true,
    emailAlerts: true,
    twoFactorAuth: false,
    language: 'en',
    sessionTimeout: 30,
    autoSave: true
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await fetch('http://localhost:8000/api/admin/auth/settings', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setSettings(data);
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const response = await fetch('http://localhost:8000/api/admin/auth/settings', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(settings)
      });
      if (response.ok) {
        setMessage('Settings saved successfully!');
        setTimeout(() => setMessage(''), 3000);
      }
    } catch (error) {
      setMessage('Failed to save settings');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="settings-modal-overlay" onClick={onClose}>
      <div className="settings-modal" onClick={(e) => e.stopPropagation()}>
        <div className="settings-modal-header">
          <h2><FaCog /> Settings</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="settings-content">
          {message && <div className="settings-message success">{message}</div>}

          {/* Appearance Section */}
          <div className="settings-section">
            <h3><FaPalette /> Appearance</h3>
            <div className="setting-item">
              <label>Dark Mode</label>
              <button 
                className={`toggle-switch ${isDarkMode ? 'active' : ''}`}
                onClick={toggleDarkMode}
              >
                {isDarkMode ? '🌙 Dark' : '☀️ Light'}
              </button>
            </div>
          </div>

          {/* Notifications Section */}
          <div className="settings-section">
            <h3><FaBell /> Notifications</h3>
            <div className="setting-item">
              <label>Enable Notifications</label>
              <input 
                type="checkbox" 
                checked={settings.notifications}
                onChange={(e) => setSettings({...settings, notifications: e.target.checked})}
              />
            </div>
            <div className="setting-item">
              <label>Email Alerts</label>
              <input 
                type="checkbox" 
                checked={settings.emailAlerts}
                onChange={(e) => setSettings({...settings, emailAlerts: e.target.checked})}
              />
            </div>
          </div>

          {/* Security Section */}
          <div className="settings-section">
            <h3><FaLock /> Security</h3>
            <div className="setting-item">
              <label>Two-Factor Authentication</label>
              <input 
                type="checkbox" 
                checked={settings.twoFactorAuth}
                onChange={(e) => setSettings({...settings, twoFactorAuth: e.target.checked})}
              />
            </div>
            <div className="setting-item">
              <label>Session Timeout (minutes)</label>
              <select 
                value={settings.sessionTimeout}
                onChange={(e) => setSettings({...settings, sessionTimeout: parseInt(e.target.value)})}
              >
                <option value="15">15 minutes</option>
                <option value="30">30 minutes</option>
                <option value="60">1 hour</option>
                <option value="120">2 hours</option>
              </select>
            </div>
          </div>

          {/* Data Section */}
          <div className="settings-section">
            <h3><FaDatabase /> Data Management</h3>
            <div className="setting-item">
              <label>Auto-save forms</label>
              <input 
                type="checkbox" 
                checked={settings.autoSave}
                onChange={(e) => setSettings({...settings, autoSave: e.target.checked})}
              />
            </div>
          </div>

          <div className="settings-actions">
            <button type="button" className="cancel-btn" onClick={onClose}>
              <FaTimes /> Close
            </button>
            <button type="button" className="save-btn" onClick={handleSave} disabled={loading}>
              <FaSave /> {loading ? 'Saving...' : 'Save Settings'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Settings;